import React, { Component, useEffect, useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  StatusBar,
  ScrollView,
  ImageBackground,
  Platform,
} from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";

import { StackActions, NavigationActions } from "react-navigation";
import styles from "./styles";
import {
  candidatarVaga,
  dispensarVaga,
  getAluno,
  listarVagas,
} from "../../services/aluno-service";
import Toast from "react-native-tiny-toast";
import { EventRegister } from "react-native-event-listeners";

import ConfirmarDados from "../../components/ConfirmarDados";
import CardVaga from "../../components/CardVaga";
import { Alert } from "react-native";

function Vaga({ navigation }) {
  const { vaga } = navigation.state.params;

  const [idModalConfirm, setIdModalConfirm] = useState(0);

  const [loading, setLoading] = useState(true);

  const requisitos = vaga.requisitos ? vaga.requisitos.split(";") : [];
  const beneficios = vaga.beneficios ? vaga.beneficios.split(";") : [];

  const candidatarSe = async () => {
    try {
      const response = await candidatarVaga(idModalConfirm);

      if (!response.ok) return console.log(await response.json());

      setIdModalConfirm(0);

      Toast.show("Candidatura Realizada. Aguarde o contato da empresa.");

      EventRegister.emit("reloadCandidaturas", idModalConfirm);

      navigation.pop(1);
    } catch (e) {
      console.error(e);
    }
  };

  const dispensar = async () => {
    try {
      const response = await dispensarVaga(vaga.id);
      if (!response.ok) return console.log(await response.json());
      setIdModalConfirm(0);
      Toast.show("Vaga dispensada.");
      EventRegister.emit("reloadVagas");
      EventRegister.emit("reloadHome");
      navigation.pop(1);
    } catch (e) {
      console.error(e);
    }
  };

  console.log(vaga);
  return (
    <>
      {idModalConfirm !== 0 && (
        <ConfirmarDados
          fechar={() => setIdModalConfirm(0)}
          dispensar={() => {}}
          confirmar={candidatarSe}
        />
      )}
      <ImageBackground
        source={require("../../../resources/imgs/bg.jpg")}
        style={[styles.container]}
        imageStyle={styles.imageContainer}
      >
        <ScrollView style={[{ height: 100, paddingVertical: 10 }]}>
          <View style={[styles.personalData, { marginBottom: 20 }]}>
            <View style={styles.header}>
              <Text style={styles.textHeader}>Destalhes da Vaga</Text>
            </View>
            <View style={styles.body}>
              <Text style={styles.dataProperty}>EMPRESA:</Text>
              <Text style={styles.dataValue}>{vaga.empresa}</Text>
              <Text style={styles.dataProperty}>TIPO CONTRATO:</Text>
              <Text style={styles.dataValue}>{vaga.tipo_vaga}</Text>
              <Text style={styles.dataProperty}>CARGO:</Text>
              <Text style={styles.dataValue}>{vaga.cargo}</Text>
              <Text style={styles.dataProperty}>ATRIBUIÇÕES:</Text>
              <Text style={styles.dataValue}>{vaga.atribuicoes}</Text>
              <Text style={styles.dataProperty}>REQUISITOS:</Text>
              {requisitos.length === 0 ? (
                <Text style={styles.dataValue}>Nenhum requisito informado</Text>
              ) : (
                <Text style={styles.dataValue}>
                  {requisitos.map(
                    (r, i) => `- ${r}${i < requisitos.length - 1 ? "\n" : ""}`
                  )}
                </Text>
              )}
              <Text style={styles.dataProperty}>LOCAL DE TRABALHO:</Text>
              <Text style={styles.dataValue}>{vaga.local_trabalho}</Text>
              <Text style={styles.dataProperty}>HORÁRIO:</Text>
              <Text style={styles.dataValue}>{vaga.horario}</Text>
              <Text style={styles.dataProperty}>SALÁRIO:</Text>
              {vaga.salario ? (
                <Text style={styles.dataValue}>R$ {vaga.salario}</Text>
              ) : (
                <Text style={styles.dataValue}>Não informado</Text>
              )}

              <Text style={styles.dataProperty}>BENEFICIOS:</Text>
              {beneficios.length === 0 ? (
                <Text style={styles.dataValue}>Nenhum benefício informado</Text>
              ) : (
                <Text style={styles.dataValue}>
                  {beneficios.map(
                    (r, i) => `- ${r}${i < beneficios.length - 1 ? "\n" : ""}`
                  )}
                </Text>
              )}
              <View
                style={{ flexDirection: "row", justifyContent: "space-evenly" }}
              >
                <TouchableOpacity
                  style={{ alignItems: "center", padding: 5 }}
                  onPress={() => {
                    if (
                      Platform.OS === "web" &&
                      window.confirm(
                        "Deseja realmente dispensar essa oportunidade?"
                      )
                    )
                      dispensar(idModalConfirm);
                    else
                      Alert.alert(
                        "Confirmar",
                        "Deseja realmente dispensar essa oportunidade?",
                        [
                          {
                            text: "Sim",
                            onPress: () => dispensar(),
                          },
                          {
                            text: "Não",
                            style: "cancel",
                          },
                        ]
                      );
                  }}
                >
                  <Text
                    style={{
                      fontFamily: "Montserrat-Medium",
                      color: "red",
                      fontSize: 18,
                    }}
                  >
                    Dispensar
                  </Text>
                </TouchableOpacity>
                {(vaga.publica === 1 || vaga.status === 1) && (
                  <TouchableOpacity
                    style={{ alignItems: "center", padding: 5 }}
                    onPress={() => setIdModalConfirm(vaga.id)}
                  >
                    <Text
                      style={{
                        fontFamily: "Montserrat-Medium",
                        color: "#00F",
                        fontSize: 18,
                      }}
                    >
                      Candidatar-se
                    </Text>
                  </TouchableOpacity>
                )}
              </View>
            </View>
          </View>
        </ScrollView>
      </ImageBackground>
    </>
  );
}

Vaga.navigationOptions = ({ navigation }) => {
  return {
    headerStyle: {
      backgroundColor: "#0F0F0F",
    },
    headerTitleStyle: {
      color: "#FFF",
    },
    headerTitle: "OPORTUNIDADE",
    headerLeft: () => (
      <TouchableOpacity
        onPress={() => {
          navigation.pop(1);
        }}
      >
        <Icon
          style={styles.iconToggle}
          name="arrow-left"
          size={20}
          color="#F1F1F1"
        />
      </TouchableOpacity>
    ),
  };
};

export default Vaga;
